import { jsx as _jsx } from "react/jsx-runtime";
import { Snackbar } from '@wayste/sour-ui';
export const Toast = ({ isToastActive, closeToast, toastProps, }) => {
    const { handleOnClose, message, position = 'top-right', severity, duration = 2500, onlyCloseOnClick = false } = toastProps;
    const handleCloseReason = () => {
        if (handleOnClose) {
            handleOnClose();
            closeToast();
        }
        else {
            closeToast();
        }
    };
    const getPosition = () => {
        switch (position) {
            case 'top-right':
                return { vertical: 'top', horizontal: 'right' };
            case 'top-center':
                return { vertical: 'top', horizontal: 'center' };
            case 'top-left':
                return { vertical: 'top', horizontal: 'left' };
            case 'bottom-right':
                return { vertical: 'bottom', horizontal: 'right' };
            case 'bottom-center':
                return { vertical: 'bottom', horizontal: 'center' };
            case 'bottom-left':
                return { vertical: 'bottom', horizontal: 'left' };
            default:
                return { vertical: 'top', horizontal: 'right' };
        }
    };
    return (_jsx(Snackbar, { open: isToastActive, message: message || 'This is a test message. Your updated has failed. You are an awful developer.', position: getPosition(), severity: severity, onClose: handleCloseReason, duration: onlyCloseOnClick ? undefined : duration }));
};
//# sourceMappingURL=toast.js.map